module.exports = __webpack_public_path__ + "img/pantalla-6-2-2.893edefe.png";